import React from 'react';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import Icon from '../../../Icon';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import { getPath } from 'utils/Router';
import {
    getConversionStatus,
    getDataCommissionCurrency,
    getRegionNameRecursively
} from '../../../../helpers/common';
import {
    renderCplAmount,
    renderCps
} from '../../../modules/index';
import {
    getQuery,
    getAvailableDevices
} from '../../../modules';
import helperColumns from "../../../DataComponent/helper";

const conversion = (state) => state.conversions.item;
const loading = (state) => state.conversions.loading;
const currency = (state) => state.currency.list;
const regions = (state) => state.regions.list;

export const isEmpty = createSelector(
    conversion,
    (conversion = {}) => {
        return !Object.keys(conversion).length;
    }
);

export const mainSelector = createSelector(
    conversion,
    loading,
    currency,
    regions,
    (conversion = {}, loading, currency = [], regions = []) => {
        if (!Object.keys(conversion).length || loading) return;

        let offerPath = getPath('offer', {id: conversion.OfferId});
        let region = conversion.RegionCountryCode + ', ' + conversion.RegionTitle

        return {
            common: {
                id: conversion.ConversionId,
                status: getConversionStatus(conversion.FactStatus),
                createdAt: I18nFormatter.fullDateTime(helperColumns.toTimestamp(conversion.ConversionDateTime)),
                updatedAt: I18nFormatter.fullDateTime(helperColumns.toTimestamp(conversion.FactDateTime)),
                timeFromTrackToAction: I18nFormatter.fromDate(helperColumns.toTimestamp(conversion.TrackDateTime), helperColumns.toTimestamp(conversion.ConversionDateTime)),
                publisher: conversion.Publisher,
                advCid: conversion.AdvertiserUID
            },
            goal: {
                offerTitle: <Link to={offerPath}>{conversion.Offer} <Icon name={'fa-link'} /></Link>,
                goalTitle: <Link to={`${offerPath}?tab=goals`}>{conversion.Goal} <Icon name={'fa-link'} /></Link>,
                action: <Link to={`${offerPath}?tab=goals`}>{conversion.GoalActionAction} <Icon name={'fa-link'} /></Link>,
                typeAction: conversion.GoalActionActionType,
                cpaFixed: I18nFormatter.currency(conversion.PromotionPerSaleAmount, conversion.PromotionPerSaleCurrency, true),
                cpaShared: I18nFormatter.currency(conversion.PromotionPerLeadAmount, conversion.PromotionPerLeadCurrency, true)
            },
            commission: {
                saleSum:  I18nFormatter.currency(conversion.SaleSumAmount, conversion.SaleSumCurrency, true),
                cpaFixed: I18nFormatter.currency(conversion.PublisherCreditPerLeadAmount, conversion.PublisherCreditPerLeadCurrency, true),
                cpaShared: I18nFormatter.currency(conversion.PublisherCreditPerSaleAmount, conversion.PublisherCreditPerSaleCurrency, true)
            },
            track: {
                createdAt: I18nFormatter.fullDateTime(helperColumns.toTimestamp(conversion.TrackDateTime)),
                ip: conversion.Ip,
                device: getAvailableDevices([{
                    type: conversion.DeviceType,
                    os: conversion.DeviceOs,
                    browser: conversion.DeviceBrowser,
                }]),
                geo: region
            },
            params: {
                l: conversion.LinkId,
                utm_source: conversion.UtmSource,
                utm_medium: conversion.UtmMedium,
                utm_term: conversion.UtmTerm,
                utm_content: conversion.UtmContent,
                utm_campaign: conversion.UtmCampaign,
                param1: conversion.Param1,
                param2: conversion.Param2,
                param3: conversion.Param3,
                param4: conversion.Param4
            },
            currency: {}
            /*
            //return if need
            getDataCommissionCurrency(
                conversion.currency_ratio,
            conversion.commission.publisher_credit_per_lead.currency,
            conversion.commission.publisher_credit_per_sale.currency*/
        };
    }
);
